import React, { RefObject } from 'react';
import { BsX } from "react-icons/bs";
import { Video } from '../types';

interface VideoSelectorProps {
  isVideoMenuOpen: boolean;
  videos: Video[];
  activeVideoId: string | undefined;
  isVideoMenuLoading: boolean;
  onVideoSelect: (video: Video) => void;
  onClose: () => void;
  menuRef: RefObject<HTMLDivElement>;
  isWalkthroughMode?: boolean; // Flag to bypass subscription checks during walkthrough
}

const VideoSelector: React.FC<VideoSelectorProps> = ({
  isVideoMenuOpen,
  videos,
  activeVideoId,
  isVideoMenuLoading,
  onVideoSelect,
  onClose,
  menuRef,
  isWalkthroughMode = false
}) => {
  if (!isVideoMenuOpen) return null;

  return (
    <div className="video-selection-menu" ref={menuRef}>
      <div className="video-menu-header">
        <h3>Choose your lofizone</h3>
        <button className="close-menu-button" onClick={onClose}>
          <BsX />
        </button>
      </div>
      {isVideoMenuLoading ? (
        <div className="video-menu-loading">
          <div className="loading-spinner"></div>
          <p>Loading backgrounds...</p>
        </div>
      ) : (
        <div className="video-thumbnails-container">
          {videos.map((video) => (
            <div 
              key={video.id}
              className={`video-thumbnail ${activeVideoId === video.id ? 'active' : ''}`}
              onClick={() => onVideoSelect(video)}
            >
              {video.thumbnailUrl ? (
                <img 
                  src={video.thumbnailUrl} 
                  alt={video.title} 
                  className="video-thumbnail-image loaded"
                />
              ) : (
                <div className="video-thumbnail-placeholder">
                  {video.title.substring(0, 1)}
                </div>
              )}
              <div className="video-thumbnail-title">{video.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoSelector; 